import { Trash2 } from 'lucide-react'

interface Props {
  onDelete: () => void
  label: string
}

export function RowDeleteButton({ onDelete, label }: Props) {
  return (
    <button
      type="button"
      tabIndex={-1}
      title={`Delete ${label}`}
      aria-label={`Delete ${label}`}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        const ok = window.confirm(`Delete this ${label}? This cannot be undone.`)
        if (ok) onDelete()
      }}
      className="flex-shrink-0 flex items-center justify-center rounded opacity-0 group-hover:opacity-100 transition-opacity hover:bg-danger-bg"
      style={{ width: 20, height: 20, color: 'var(--color-fg-muted)', background: 'transparent', border: 0, padding: 0 }}
    >
      <Trash2 size={12} />
    </button>
  )
}
